import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { Logo } from "@resources";
import { NavMenu, useNavMenu } from "@components";
import { useHeader } from "./headers";

interface LoginHeaderProps {
    id?: string;
    className?: string;
}

const LoginHeader: React.FC<LoginHeaderProps> = ({ id, className }) => {
    const navigate = useNavigate();
    const { navigateHome } = useHeader();
    // NOTE: under normal circumstances, the menu is not being shown here; you
    // should only be seeing this state while logged out.  That said, in case
    // the user got into a weird state, it's important he can still access the
    // menu to still use the app, or to log out/in to fix the header, etc.
    const { showMenu } = useNavMenu();

    return (
        <header id={id} className={classNames(
            `flex flex-row px-4 py-2.5 md:px-8 md:py-4 items-center bg-white border-b border-neutral-100 w-full h-[60px] md:h-24`,
            showMenu ? `justify-between` : `justify-center`,
            className
        )}>
            <div
                onClick={navigateHome ? () => navigate(`/`) : undefined}
                {...(navigateHome && { tabIndex: 0, role: `button`, "aria-label": `Go to home page` })}
                className={classNames(`focus-visible:outline-focus-ring rounded`, navigateHome && `cursor-pointer`)}
                {...(navigateHome && {
                    onKeyDown: (e: React.KeyboardEvent) => {
                        if (e.key === `Enter` || e.key === ` `) {
                            e.preventDefault();
                            navigate(`/`);
                        }
                    }
                })}
            >
                <Logo className="h-8 w-auto text-neutral-950" />
            </div>
            {showMenu && (
                <div className="md:self-end">
                    <NavMenu />
                </div>
            )}
        </header>
    );
};

export default LoginHeader;
